import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../component/component/Auth/reduxSlice"
const reducers = combineReducers({
 auth : authReducer
});

export const store = configureStore({
  reducer: reducers,
});
